<!-- <div class="justify-content-center align-content-center center-screen mt-2 mb-4">
  <div class="d-flex align-content-center justify-content-center my-3"> -->

<ng-container class="d-flex mt-3">
  <div fxLayout="row" class="container container-sm" fxLayoutAlign="center center" fxLayoutGap="6px">

    <form [formGroup]="ratesAndFeesForm" class="pt-3">
      <div class="card rounded-2 shadow-2-soft">
        <div class="card-header p-1">
          <div class="idlight ms-auto me-auto rounded-2 shadow-2-strong center-screen py-3">
            <div class="d-inline-flex justify-content-around align-content-center">
              <div *ngFor="let product of lstProductTypes; let i as index;" style="flex-wrap: nowrap;
                                  flex-grow: 1 auto;">
                <button type="button" class="btn me-2" mdbRipple rippleColor="dark" color="primary"
                  [ngClass]="{'btn-primary':ratesAndFeesModel.id == product.id, 'btn-outline-primary':ratesAndFeesModel.id != product.id}"
                  (click)="ratesAndFeesModel=product;showProduct(product);">{{product.description}}</button>
              </div>
            </div>
          </div>
        </div>

        <div class="card-body mb-2 p-3">
          <div class="container-fluid ms-auto me-auto">
            <div class="d-flex center-screen">
              <table id="productRates" w900
                class="table table-striped table-fixed table-sm mb-2 shadow-2-strong rounded-1 p-1 my-2"
                [style.width.px]="900" style="text-align: left;">
                <caption>Product Parameters</caption>
                <tbody class="field-4column-label">
                  <tr>
                    <td>Code</td>
                    <td>
                      <input type="text" formControlName="code" [(ngModel)]="ratesAndFeesModel.code">
                      <!-- <div *ngIf="validateRatesAndFeesValues.code.errors?.required && submitted" class="error-label">
                            Code is required
                          </div> -->
                    </td>

                    <td>Description</td>
                    <td>
                      <input type="text" formControlName="description"
                        [(ngModel)]="ratesAndFeesModel.description" required>
                      <div *ngIf="validateRatesAndFeesValues.description.errors?.required && submitted"
                        class="error-label">
                        Description is required
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Minimum Loan Amount</td>
                    <td>
                      <input type="text" formControlName="minimumLoan"
                        [(ngModel)]="ratesAndFeesModel.minimumLoan" required>
                      <div *ngIf="validateRatesAndFeesValues.minimumLoan.errors?.required && submitted"
                        class="error-label">
                        Minimum loan is required
                      </div>
                    </td>

                    <td>Maximum Loan Amount</td>
                    <td>
                      <input type="text" formControlName="maximumLoan"
                        [(ngModel)]="ratesAndFeesModel.maximumLoan" required>
                      <div *ngIf="validateRatesAndFeesValues.maximumLoan.errors?.required && submitted"
                        class="error-label">
                        Maximum Loan is required
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>Interest rate 1st loan (%)</td>
                    <td>
                      <input type="text" formControlName="interestRate1st"
                        [(ngModel)]="ratesAndFeesModel.interestRate1st" required>
                      <div *ngIf="validateRatesAndFeesValues.interestRate1st.errors?.required && submitted"
                        class="error-label">
                        Interest rate 1st loan is required
                      </div>
                    </td>
                    <td>Interest rate other loans (%)</td>
                    <td>
                      <input type="text" formControlName="interestRateOther"
                        [(ngModel)]="ratesAndFeesModel.interestRateOther" required>
                      <div *ngIf="validateRatesAndFeesValues.interestRateOther.errors?.required && submitted"
                        class="error-label">
                        Interest rate other is required
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>Initiation fee if cap below 1000 (%)</td>
                    <td>
                      <input type="text" formControlName="initFeeBelow1000"
                        [(ngModel)]="ratesAndFeesModel.initFeeBelow1000">
                    </td>
                    <td>Initiation fee first 1000</td>
                    <td>
                      <input type="text" formControlName="initFeeFirst1000"
                        [(ngModel)]="ratesAndFeesModel.initFeeFirst1000">
                    </td>
                  </tr>

                  <tr>
                    <td>Initiation fee (%)</td>
                    <td>
                      <input type="text" formControlName="initiationFee"
                        [(ngModel)]="ratesAndFeesModel.initiationFee" required>
                      <div *ngIf="validateRatesAndFeesValues.initiationFee.errors?.required && submitted"
                        class="error-label">
                        Initiation fee is required
                      </div>
                    </td>

                    <td>Initiation fee cap</td>
                    <td>
                      <input type="text" formControlName="initiationCap"
                        [(ngModel)]="ratesAndFeesModel.initiationCap" required>
                      <div *ngIf="validateRatesAndFeesValues.initiationCap.errors?.required && submitted"
                        class="error-label">
                        Initiation fee cap is required
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>My Benefits (%)</td>
                    <td>
                      <input type="text" formControlName="myBenefits"
                        [(ngModel)]="ratesAndFeesModel.myBenefits" required>
                      <div *ngIf="validateRatesAndFeesValues.myBenefits.errors?.required && submitted"
                        class="error-label">
                        My Benefits is required
                      </div>
                    </td>
                    <td>Term in months</td>
                    <td>
                      <input type="text" formControlName="term" [(ngModel)]="ratesAndFeesModel.term" required>
                      <div *ngIf="validateRatesAndFeesValues.term.errors?.required && submitted" class="error-label">
                        Term is required
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>Factor 1st loan</td>
                    <td>
                      <input type="text" formControlName="factor1stLoan"
                        [(ngModel)]="ratesAndFeesModel.factor1stLoan">
                    </td>
                    <td>Factor other loans</td>
                    <td>
                      <input type="text" formControlName="factorOtherLoan"
                        [(ngModel)]="ratesAndFeesModel.factorOtherLoan">
                    </td>
                  </tr>

                  <tr>
                    <td>Factor up to 850</td>
                    <td>
                      <input type="text" formControlName="factorUpTo850"
                        [(ngModel)]="ratesAndFeesModel.factorUpTo850">
                    </td>
                    <td>Factor up to 1000</td>
                    <td>
                      <input type="text" formControlName="factorUpTo1000"
                        [(ngModel)]="ratesAndFeesModel.factorUpTo1000">
                    </td>
                  </tr>

                  <tr>
                    <td>Monthly service fee</td>
                    <td>
                      <input type="text" formControlName="monthlyServiceFee"
                        [(ngModel)]="ratesAndFeesModel.monthlyServiceFee" required>
                      <div *ngIf="validateRatesAndFeesValues.monthlyServiceFee.errors?.required && submitted"
                        class="error-label">
                        Monthly service fee is required
                      </div>
                    </td>
                    <td>Initiation service fee cap (%)</td>
                    <td>
                      <input type="text" formControlName="initServiceFeeCap"
                        [(ngModel)]="ratesAndFeesModel.initServiceFeeCap" required>
                      <div *ngIf="validateRatesAndFeesValues.initServiceFeeCap.errors?.required && submitted"
                        class="error-label">
                        Initiation service fee cap is required
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>Max days before first payment</td>
                    <td>
                      <input formControlName="maxDays" [(ngModel)]="ratesAndFeesModel.maxDays" required>
                      <div *ngIf="validateRatesAndFeesValues.maxDays.errors?.required && submitted" class="error-label">
                        Max days before first payment is required
                      </div>
                    </td>
                    <td>Regulatory type</td>
                    <td>
                      <mdb-select class="select table-control" formControlName="regulatoryType"
                        [(ngModel)]="ratesAndFeesModel.regulatoryType" required>
                        <mdb-option *ngFor="let regType of lstRegulatory;" [value]="regType.value">
                          {{regType.description}}
                        </mdb-option>
                      </mdb-select>
                      <div *ngIf="validateRatesAndFeesValues.regulatoryType.errors?.required && submitted"
                        class="error-label">
                        Regulatory type is required
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>MyBenefits Document tier</td>
                    <td>
                      <mdb-select class="select table-control " formControlName="mybenefitsTier"
                        (change)="onSelect($event)" required>
                        <mdb-option *ngFor="let myben of lstmyBenefitTier;" [value]="myben.value">
                          {{myben.description}}
                        </mdb-option>
                      </mdb-select>
                      <div *ngIf="validateRatesAndFeesValues.mybenefitsTier.errors?.required && submitted"
                        class="error-label">
                        MyBenefits document tier is required
                      </div>
                    </td>
                    <td colspan="2"></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-flex center-screen">
              <!-- Product Fee calculations -->
              <table id="serviceFees" class="table table-striped table-sm mb-2 shadow-2-strong rounded-1 p-1 my-2"
                [style.width.px]=900 style="text-align: left;">
                <caption>Product Fee calculations</caption>
                <tbody class="field-4column-label">
                  <tr>
                    <td>Loan Type</td>
                    <td>
                      <input style="width: 250px;" formControlName="type" [(ngModel)]="ratesAndFeesModel.type" required>
                      <div *ngIf="validateRatesAndFeesValues.type.errors?.required && submitted" class="error-label">
                        Loan type is required
                      </div>
                    </td>
                    <td>Regulatory type</td>
                    <td>
                      <input style="width: 250px;" formControlName="regulatoryType"
                        [(ngModel)]="ratesAndFeesModel.regulatoryType">
                      <div *ngIf="validateRatesAndFeesValues.regulatoryType.errors?.required && submitted"
                        class="error-label">
                        Regulatory type is required
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>Max days before first payment</td>
                    <td>
                      <input formControlName="maxDays" [(ngModel)]="ratesAndFeesModel.maxDays" required>
                      <div *ngIf="validateRatesAndFeesValues.maxDays.errors?.required && submitted" class="error-label">
                        Max days before first payment is required
                      </div>
                    </td>
                    <td>Calculation type</td>
                    <td>
                      <input formControlName="calculationType" [(ngModel)]="ratesAndFeesModel.calculationType">
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div><!-- END: card-body -->
        <div class="card-footer flex-container">
          <button class="btn btn-danger me-5" (click)="openDeleteProductDialog(ratesAndFeesModel)">
            <i class="fas fa-trash-can  fa-fw me-1"></i>
            Delete Product
          </button>
          <button class="btn btn-primary" mdbRipple (click)="openAddProductDialog()">
            <i class="fas fa-laptop-medical fa-fw me-1"></i>
            Add New
          </button>
          <button class="btn btn-primary " mdbRipple (click)="saveUpdateLoanType(ratesAndFeesModel)">Save
          </button>
        </div>

      </div><!-- END: card -->
    </form>
  </div>
</ng-container>
